import { AccessSource } from '@prisma/client';
import { TableProps } from 'antd';

import { SourceAccessItem } from '@app/domain-access-interfaces';

import { AgsApproverTable } from './ags-approver-table';

export type ApproverTableProps = TableProps & SourceAccessItem;

export const ApproverTable = ({ accessSource, externalId, ...props }: ApproverTableProps) => {
  switch (accessSource) {
    case AccessSource.AGS_ROLE:
    case AccessSource.AGS_ENTITLEMENT:
      return <AgsApproverTable accessSource={accessSource} externalId={externalId} {...props} />;
    case AccessSource.IEM:
      return <span>Sorry, displaying IEM unix group approvers is not supported.</span>;
    default:
      throw new Error(`Access source type '${accessSource}' is not supported by this control.`);
  }
};
